import React from 'react';
import { Alert } from '@op/opds.opux';

interface ErrorNotificationProps {
  message: string;
}

const ErrorNotification: React.FC<ErrorNotificationProps> = ({ message }) => (
  <Alert type="critical">{message}</Alert>
);

export default ErrorNotification;
